import { Box, Stack, Text } from '@mantine/core'
import { Link, Outlet, createFileRoute, useRouterState } from '@tanstack/react-router'

export const Route = createFileRoute('/dev')({
  head: () => ({
    meta: [
      { title: 'Dev — Patter' },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  }),
  component: DevLayoutRoute,
})

function DevLayoutRoute() {
  const pathname = useRouterState({
    select: state => state.location.pathname,
  })
  const isDevIndex = pathname === '/dev' || pathname === '/dev/'

  if (!isDevIndex) {
    return <Outlet />
  }

  return (
    <Box bg="#18181b" component="main" mih="100dvh" p="xl">
      <Stack gap="lg" maw={400}>
        <Text fw={700} size="xl">
          Dev tools
        </Text>
        <Stack gap={6}>
          <Text component={Link} fw={600} size="sm" to="/dev/playground">
            Playground
          </Text>
          <Text component={Link} fw={600} size="sm" to="/dev/particles">
            Particles
          </Text>
          <Text component={Link} fw={600} size="sm" to="/dev/run-summary">
            Run summary animation
          </Text>
        </Stack>
        <Text c="dimmed" component={Link} fw={600} size="sm" to="/">
          ← Home
        </Text>
      </Stack>
    </Box>
  )
}
